export const ASSETS = {
  logoMark:
    "https://static.prod-images.emergentagent.com/jobs/dab27f1f-ffa6-43fb-ab8a-5131b576daae/images/b65112c3a2207dc39fd1bfd55b141998db8c5abe7b1d267661d579d4eb81acd7.jpeg",
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/dab27f1f-ffa6-43fb-ab8a-5131b576daae/images/68729db6e247504487f102dd00283ac5d117f91ce62670ef649288b976f191a0.jpeg",
  featureAi:
    "https://static.prod-images.emergentagent.com/jobs/dab27f1f-ffa6-43fb-ab8a-5131b576daae/images/51c369fecaa241f46531832ab496f9f21e49928f93d1f82ea2ca05a728ea2da5.jpeg",
  showcaseBg:
    "https://static.prod-images.emergentagent.com/jobs/dab27f1f-ffa6-43fb-ab8a-5131b576daae/images/9789d14bb8547774fa1619f722dd4e385371f9b816fde889acd19c2dce5daeb2.jpeg",
  ctaBg:
    "https://static.prod-images.emergentagent.com/jobs/dab27f1f-ffa6-43fb-ab8a-5131b576daae/images/b6f4e6c1f0a075bf3dc4b39d21b4a0c43d1f73b80e5e0df2b91c74839cc249c7.jpeg",
};
